<template>
  <footer class="flex min-h-[4rem] w-full items-center justify-center bg-gray-600 text-white">
    <NuxtLink
      :href="$t('privacyPolicy.href')"
      class="underline"
      target="_blank">
      {{ $t('privacyPolicy.label') }}
    </NuxtLink>
  </footer>
</template>
